import { Pipe, PipeTransform } from '@angular/core';
import { WorkMontageplanUsersUserPartial, WorkTablesoccerUserDto, WorkUser, WorkUserV2 } from '@work-frontend-monorepo/work-rest-api';

@Pipe({
  name: 'getInitials',
  standalone: true,
})
export class GetInitialsPipe implements PipeTransform {
  transform(user: WorkUser | WorkUserV2 | WorkTablesoccerUserDto | WorkMontageplanUsersUserPartial): string {
    if (user && user.firstName && user.lastName) {
      return user.firstName.substring(0, 1) + user.lastName.substring(0, 1);
    }
    return '-';
  }
}
